let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("7u5Uq"), load("ffEVr"), load("aRnD4")]).then(() => parcelRequire('fgp6d'));